import {
  AutocompleteArrayInput
} from 'react-admin';

export default function SelectEmployeeFieldCreate({allEmployee}) {

  return (
      <AutocompleteArrayInput
        optionText="fullname"
        source="employeeIDs"
        label="Employees"
        variant="outlined"
        fullWidth
        choices={allEmployee}
      />
  );
}
